import { Button } from '@smartsheet/lodestar-core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Divider } from './styled';

export const SignInWithSmartsheet = () => {
  const { t: translate } = useTranslation();
  const initiateSmartsheetSignIn = () => {
    window.location.href = '/v2/oauth/login';
  };
  return (
    <>
      <Divider />
      <Button
        appearance="secondary"
        shouldFitContainer={true}
        onClick={initiateSmartsheetSignIn}
      >
        {translate('signin:signinWithSmartsheet')}
      </Button>
    </>
  );
};
